import {Toast, Modal} from 'antd-mobile';
import {langCheck} from 'src/hrzz/public/mobile/utils/utils'
import nccmb from "../../ncc-moible/nccmb";
import handleAuthExpired, {getAuthExpiredMessage, notifyAppLogout} from './authExpired';

let _loadingCount = 0;
let _loadingTimer = null;
const showLoading = () => {
    _loadingCount++;
    if (_loadingCount === 1) {
        Toast.loading(langCheck('hrzzmb-000001', false, null, "hrzzmb"), 0);
    }
    // 防止某些路径未调用 hideLoading 导致卡死，20s 后自动隐藏一次
    if (_loadingTimer) clearTimeout(_loadingTimer);
    _loadingTimer = setTimeout(() => {
        _loadingCount = 0;
        Toast.hide();
        _loadingTimer = null;
    }, 20000);
};

const hideLoading = () => {
    _loadingCount--;
    if (_loadingCount <= 0) {
        _loadingCount = 0;
        Toast.hide();
        if (_loadingTimer) {
            clearTimeout(_loadingTimer);
            _loadingTimer = null;
        }
    }
};

export default ({
                    data,
                    url,
                    loading,
                    headers = {'Content-Type': 'application/json;charset=UTF-8',"accesstoken":localStorage.getItem('accessToken')},
                    info = {},
                    noNeedShowError = false, //判断是否抛错，默认需要
                    ...other
                }) => {
    !loading && showLoading();

    return new Promise((resolve, reject) => {

        const errFun = (err) => {
            hideLoading();
            handleAuthExpired(err);
            let errMsg;
            if (err && err.response && err.response.status === 413) {
                errMsg = langCheck('hrzzmb-000348', false, null, "hrzzmb")
                /*多语: 请求数据过大，请检查图片或文件大小。*/;
            } else {
                const responseData = err && err.response && err.response.data;
                const data = err && err.data;
                errMsg = (responseData && responseData.message) ||
                    (data && data.message) ||
                    (err && err.message) ||
                    (data && data.error && data.error.message);
            }
            // 提示
            errMsg = getAuthExpiredMessage(err, errMsg);
            !noNeedShowError && Modal.alert(langCheck('hrzzmb-000002', false, null, "hrzzmb"), errMsg, [
                {text: langCheck('hrzzmb-000003', false, null, "hrzzmb"), onPress: () => notifyAppLogout(err)},
            ]);
            // 确定
            // Toast.fail(err.message||err.data.error.message);
            reject({
                ...err,
                data: {
                    error: {
                        message: errMsg
                    }
                },
                success: false
            });
        }

        nccmb.callAction({
            data,
            url,
            headers,
            info,
            success: (res) => {
                hideLoading();
                handleAuthExpired(res);
                if (res.code === '200' || res.code === '1000000000') {
                    res.success = true;
                    resolve(res);
                } else {
                    errFun(res)
                }
            },
            error: (err) => errFun(err),
            ...other,
        })
    })
}